export enum ReportRoutes {
  PREVIEW = 'preview',
  VIEW = ':reportId',
}
